function initLenis() {
  // Access Lenis from window since it's loaded as a global
  const LenisConstructor = window.Lenis;
  if (!LenisConstructor) {
    // Wait for Lenis to load
    setTimeout(initLenis, 50);
    return;
  }

  const lenis = new LenisConstructor({
    autoRaf: true,
  });
  window.lenis = lenis;
}

initLenis();
